import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

import { PHOTOS } from "@/lib/data";
const HERO_IMG = PHOTOS.hero;

const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end pt-24 pb-12 md:pb-20 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Editorial portrait in warm window light"
          className="h-full w-full object-cover"
          style={{ objectPosition: "center center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F9F8F6]/10 via-[#F9F8F6]/0 to-[#F9F8F6]/95" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F9F8F6]/40 via-transparent to-[#F9F8F6]/55" />
        <div className="grain absolute inset-0" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1500px] w-full px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 items-end">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
            className="col-span-12 md:col-span-8 lg:col-span-7"
          >
            <p className="overline mb-6 text-[#5C5C5C]" data-testid="hero-overline">
              Photography · Est. 2019
            </p>
            <h1
              data-testid="hero-heading"
              className="serif text-[2.7rem] sm:text-6xl md:text-7xl lg:text-[5.6rem] leading-[0.95] tracking-tight text-[#2A2A2A] font-light"
            >
              Capturing moments,
              <br />
              <span className="italic text-[#C48B71]">creating</span> visions.
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.45 }}
            className="col-span-12 md:col-span-4 lg:col-span-4 lg:col-start-9 md:pb-3"
          >
            <p className="text-[#2A2A2A] text-base md:text-[1.05rem] leading-relaxed font-normal max-w-sm drop-shadow-[0_1px_2px_rgba(249,248,246,0.6)]">
              Capturing your <em className="serif">Main Visions</em> — the
              priceless, blink-and-you'll-miss-it moments that deserve to be
              remembered forever.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#gallery"
                data-testid="hero-cta-portfolio"
                className="btn-primary"
              >
                View Portfolio <ArrowDownRight size={16} strokeWidth={1.4} />
              </a>
              <a
                href="#book"
                data-testid="hero-cta-book"
                className="btn-outline"
              >
                Book a Session
              </a>
            </div>
          </motion.div>
        </div>

        {/* Marquee bottom row */}
      </div>
    </section>
  );
};

export default Hero;
